import { AJAX_GET, AJAX_POST } from '../helpers/ajax'
import {AJAX_DELETE} from "../helpers/ajax.js";

export default {
    async saveLockHeightSettings(payload) {
        return await AJAX_POST('/settings/save-default', payload)
    },
}
